module.exports = __webpack_public_path__ + "img/49.c09975c4.png";